import { getSearchClient } from "./algolia-client.js";
import { initNavbarSearchPreview } from "./navbar-search.js";
import { initSearchPage } from "./search-page.js";

function runWhenDocumentReady(callback) {
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", callback, { once: true });
  } else {
    callback();
  }
}

// The lite client ships as a CDN global. Deferred scripts run in document order, so when the
// Algolia tag comes after this bundle the global does not exist yet; wait for window load
// before giving up, and bail quietly rather than throwing on pages that do not load it.
function initSearch(canWait) {
  if (!document.querySelector(".search__results-nav") && !document.querySelector("#search")) return;

  if (!getSearchClient()) {
    if (canWait && document.readyState !== "complete") {
      window.addEventListener("load", () => initSearch(false), { once: true });
      return;
    }
    console.warn("[mx-search] algoliasearch lite global not found; search is disabled.");
    return;
  }

  initNavbarSearchPreview();
  initSearchPage();
}

runWhenDocumentReady(() => initSearch(true));
